import { render } from "./Gold.vue?vue&type=template&id=5bd366e6&scoped=true"
import script from "./Gold.vue?vue&type=script&lang=js"
export * from "./Gold.vue?vue&type=script&lang=js"

import "./Gold.vue?vue&type=style&index=0&id=5bd366e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd366e6"]])

export default __exports__